'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var COLORS = exports.COLORS = {
    NONE: { name: null, hex: null },
    GREEN: { name: 'GREEN', hex: '#9ec874' },
    BROWN: { name: 'BROWN', hex: '#d3906b' },
    RED: { name: 'RED', hex: '#ff5d69' },
    ORANGE: { name: 'ORANGE', hex: '#ff9a5c' },
    YELLOW: { name: 'YELLOW', hex: '#ffc852' },
    PINK: { name: 'PINK', hex: '#ff7cba' },
    PURPLE: { name: 'PURPLE', hex: '#aa88e9' },
    BLUE: { name: 'BLUE', hex: '#54b1ea' }
};


//////////////////
// WEBPACK FOOTER
// ./src/common/colors/colorConstants.js
// module id = 479
// module chunks = 0